module.exports = __webpack_public_path__ + "img/top.0382eea0.jpg";